import CKEditor from '@ckeditor/ckeditor5-vue2';
// import { loadProgressBar } from 'axios-progress-bar';
import Chart from 'chart.js';
import VeeValidate, { Validator } from 'vee-validate';
import VeeValidateMessagesFR from 'vee-validate/dist/locale/fr';
import Vue from 'vue';
import VueFormWizard from 'vue-form-wizard';
import 'vue-form-wizard/dist/vue-form-wizard.min.css';
import VueSweetAlert from 'vue-sweetalert';
import VueTelInput from 'vue-tel-input';
import Form from './form';
import VeeValidateCustomFR from './fr_custom.js';
import Image from './image';
import Notification from './notifications'; // it is used by snotify

window.Chart = Chart;
Validator.localize('fr', VeeValidateMessagesFR); // localize to fr
Validator.localize('fr', VeeValidateCustomFR); // dictionnary merge with custom message

const config = {
  errorBagName: 'ferrors',
  locale: 'fr',
};

require('sweetalert');
require('./bootstrap');
window.CKEDITOR = require('@ckeditor/ckeditor5-build-classic');
window.CKEDITOR.defaultConfig = {
  removePlugins: [
    'EasyImage',
    'Image',
    'ImageCaption',
    'ImageToolbar',
    'ImageUpload',
    'MediaEmbed',
  ],
  toolbar: {
    items: [
      'heading',
      '|',
      'bold',
      'italic',
      'link',
      'bulletedList',
      'numberedList',
      '|',
      'indent',
      'outdent',
      '|',
      'blockQuote',
      'insertTable',
      'undo',
      ' redo',
    ],
  },
};
require('dotenv').config();

Vue.use(CKEditor);
Vue.use(VueSweetAlert);
Vue.use(VueFormWizard);
Vue.use(VeeValidate, config);
Vue.use(VueTelInput); // Define default global options here (optional)

window.Form = Form;
window.Image = Image;
window.globalEventBus = new Vue();

/**
 * Si ca fonctionne pas on saura pourquoi xD
 * Vue.prototype.$http axios;
 */

// loadProgressBar({ parent: '#loader', showSpinner: false }, axios)

const files = require.context('./', true, /\.vue$/i);

files.keys().map((key) => {
  return Vue.component(
    _.last(key.split('/')).split('.')[0],
    files(key).default,
  );
});

const app = new Vue({
  el: '#app',
  comments: true,
  data: function() {
return {
    user: {},
  };
},
});
